<template>
  <div>
    <BusinessViewHeader
      :business="promotion.business"
      :is_loading="is_loading"
      :is_owner="is_in_public_view?false:is_owner"
      :is_on_details_view="false"
      :is_in_public_view="is_in_public_view"
      :is_in_admin_view="is_in_admin_view"
    ></BusinessViewHeader>
    <div class="pt-8 pb-4 white text-center pr-8">
      <v-btn
        v-for="(btn, index) in header_buttons"
        :key="index"
        small
        rounded
        class="mr-4"
        outlined
        :disabled="btn.disabled"
        :color="btn.color"
        @click="on_click_header_action(btn)"
      >
        <v-icon left>{{ btn.icon }}</v-icon
        >{{ btn.label }}
      </v-btn>
    </div>
    <CardedSectionHeader
      icon="mdi-television"
      label="Promotion Details"
      id="owner_view_prmotion_details_view"
    ></CardedSectionHeader>
    <CardedDisplay>
      <PlainDisplay :show_icon="false">
        <PromotionHeader
          :is_loading="is_loading"
          :promotion="promotion"
          :is_owner_view="is_owner_view"
          :is_in_admin_view="is_in_admin_view"
        ></PromotionHeader>
        <div class="grey mt-4">
          <v-img xwidth="902" min-height="902" :src="promotion.media_url" grey>
          </v-img>
        </div>
      </PlainDisplay>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-table"
      label="Site Featuring"
      id="owner_view_prmotion_details_fetures_view"
      v-if="is_owner_view == true || is_in_admin_view == true"
    ></CardedSectionHeader>
    <CardedTable
      :items="items"
      :headers="headers"
      :show_description="true"
      v-if="is_owner_view == true || is_in_admin_view == true"
      :height="items.length == 0 ? 240 : 400"
    >
      <template v-slot:description>
        <v-alert
          dense
          text
          type="warning"
          v-if="items.length == 0 && is_owner_view == true"
        >
          Looks like your
          <strong> promotion is not featured on any site advert</strong>, please
          contact
          <b class="pointer text-decoration-underline" @click="go_to_contact_us"
            >Busyug Administration,</b
          >
          if you want your promotion to be featured.
        </v-alert>
        <v-alert
          dense
          text
          type="warning"
          v-if="items.length == 0 && is_in_admin_view == true"
        >
          Looks like this
          <strong> promotion is not featured on any site advert</strong>, please
          contact <b>The business to </b> suggest featuring it, if necessary
        </v-alert>
      </template>
    </CardedTable>
    <CardedSectionHeader
      icon="mdi-graph"
      label="Promotion's View Activity Trends"
      id="owner_view_prmotion_details_view_activity_section"
      v-if="is_owner_view == true || is_in_admin_view == true"
    >
      <v-btn
        small
        rounded
        class="mr-4"
        outlined
        :disabled="is_loading"
        color="success"
        @click="go_to_promotions_report_filtered()"
        v-show="is_owner_view == true && is_in_admin_view == false"
      >
        View In Report
      </v-btn>
    </CardedSectionHeader>
    <div class="white text-left pa-4" v-if="is_owner_view == true || is_in_admin_view == true" >
      The date is in the formart <b>"d/m"</b>, where: <br/>
      &nbsp;&nbsp;&nbsp;<b class="ml-6">d</b> is for day of month <br/>
      &nbsp;&nbsp;&nbsp;<b class="ml-6">m</b> is for month of the year <br/>
      The views on a specific date are shown in brackets <b>()</b> e.g <br/>
      &nbsp;&nbsp;&nbsp; <b class="ml-6">13/2 (16)</b> means that on the 13<small>th</small> of Feb, there were 16 views
    </div>
    <SparklineGraph
      :value="grap_value"
      :labels="graph_labels"
      type="trend"
      v-if="is_owner_view == true || is_in_admin_view == true"
    >
    </SparklineGraph>

  </div>
</template>

<script>
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import BusinessViewHeader from "./../../../components/BusinessViewHeader";
import CardedSectionHeader from "./../../../components/CardedSectionHeader";
import CardedDisplay from "./../../../components/CardedDisplay";
import PlainDisplay from "./../../../components/PlainDisplay";
import PromotionHeader from "./../../../components/PromotionHeader";
import CardedTable from "./../../../components/CardedTable";
import SparklineGraph from "./../../../components/SparklineGraph";

export default {
  name: "OwnerPromtionsView",
  components: {
    BusinessViewHeader,
    CardedSectionHeader,
    CardedDisplay,
    PlainDisplay,
    PromotionHeader,
    CardedTable,
    SparklineGraph
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_owner_view: {
      type: Boolean,
      default: true,
    },
    is_in_admin_view: {
      type: Boolean,
      default: false,
    },
    is_in_public_view: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      promotion_id: 0,
      promotion: Utils.get_default_promotion(),
      is_owner: false,
      items: [],
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: true,
          value: "id",
          filterable: true,
        },
        {
          text: "Platform",
          align: "start",
          sortable: true,
          value: "platform",
          filterable: true,
        },
        {
          text: "Page",
          align: "start",
          sortable: true,
          value: "page",
          filterable: true,
        },
        {
          text: "Section",
          align: "start",
          sortable: true,
          value: "page",
          filterable: true,
        },
      ],
      grap_value: [],
      graph_labels: []
    };
  },
  methods: {
    go_to_contact_us() {
      this.$router.push("/contact");
    },
    load_promotion() {
      this.$emit("on-show-loader");
      ServerClient.Promotions.get_promotion(
        {
          id: this.promotion_id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          //   console.log("This one ", res);
          var php_time_now = parseFloat(Utils.date_str_to_php_time());
          res.expiry = "";
          if (php_time_now < parseFloat(res.starts_on_timestamp)) {
            res.expiry = "pending";
          } else if (
            php_time_now >= parseFloat(res.starts_on_timestamp) &&
            php_time_now <= parseFloat(res.ends_on_timestamp)
          ) {
            res.expiry = "live";
          } else if (php_time_now > parseFloat(res.ends_on_timestamp)) {
            res.expiry = "expired";
          }
          var temp_promo = res;
          //table items
          this.items = res.featured_promotions;
          //graph values
          var views_list = res.promotion_views;
          var plot_items = Utils.process_promo_graph_data(
            temp_promo.starts_on,
            temp_promo.ends_on,
            views_list
          );
          this.grap_value = plot_items.values;
          this.graph_labels = plot_items.labels;


          delete temp_promo.featured_promotions;
          delete temp_promo.promotion_views;

          this.promotion = temp_promo;
          if (
            this._user &&
            this._user != null &&
            this.promotion.business &&
            parseInt(this._user.id) == parseInt(this.promotion.business.user_id)
          ) {
            this.is_owner = true;
          }

          if(this.is_in_public_view == true){
            this.truck_promotion_view();
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading prmomotion details on owners promotion details view",
            errors
          );
        }
      );
    },
    on_click_header_action(btn) {
      switch (btn.action) {
        case "edit_promotion":
          this.$router.push(
            "/owner/promotions/list/view/" + this.promotion_id + "/edit"
          );
          break;
        case "end_promotion":
          this.$router.push(
            "/owner/promotions/list/view/" + this.promotion_id + "/end"
          );
          break;
        case "delete_promotion":
          if (this.is_owner_view) {
            this.$router.push(
              "/owner/promotions/list/view/" + this.promotion_id + "/delete"
            );
          }else if (this.is_in_admin_view) {
            this.$router.push(
              "/admin/promotions/list/view/" + this.promotion_id + "/delete"
            );
          }
          break;
         default:
          break;
      }
    },
    go_to_promotions_report_filtered(){
      this.$router.push("/owner/reports/promotions?id=" + this.promotion_id);
    },
    truck_promotion_view(){
      var today_str = Utils.get_today_date_str();
      var start_time_str = today_str + " 00:00:00 AM ";
      var start_time = Utils.date_str_to_php_time(start_time_str);
      var end_time_str = today_str + " 11:30:00 PM ";
      var end_time = Utils.date_str_to_php_time(end_time_str);
      ServerClient.Promotions.post_promotion_view({
        user_id: (this._user && this._user != null)? parseInt(this._user.id) : 0,
        start_time: start_time,
        end_time: end_time,
        id: this.promotion_id,
        context: "public_promotion_view",
        page: "public_promotion_view",
        section: "center_section",
        today_str:  today_str,
        current_views_count: parseInt(this.promotion.views_count)
      },(res) => {
        console.log("Successfully registered promotion view ", res);
        this.promotion.views_count = parseInt(this.promotion.views_count) + 1;
      }, (errors) => {
        console.log("Errors while posting promotions view ", errors);
      });
    }
  },
  computed:{
    header_buttons() {
      var ls = [];
      //edit promotion
      //only available to business owner
      if (this.is_owner_view) {
        ls.push({
          action: "edit_promotion",
          color: "warning",
          icon: "mdi-pen",
          label: "Edit Promotion",
          disabled: (this.is_loading || parseInt(this.promotion.has_been_ended) == 1)
        });
      }
      //End promotion
      //only available to business owner
      if (this.is_owner_view) {
        ls.push({
          action: "end_promotion",
          color: "red",
          icon: "mdi-power",
          label: "End The Promotion",
          disabled: (this.is_loading || parseInt(this.promotion.has_been_ended) == 1)
        });
      }
      //delete promotion
      //available to  owner and admin
      if (this.is_owner_view ||  this.is_in_admin_view) {
        ls.push({
          action: "delete_promotion",
          color: "red",
          icon: "mdi-trash-can",
          label: "Delete Promotion",
          disabled: this.is_loading
        });
      }
      
      return ls;
    },
  },
  mounted() {
    this.promotion_id = parseInt(this.$route.params.id);
    this._user = ServerClient.Login.get_logged_in_user();

    this.$emit("set-page-attributes", {
      title: "View Promotion",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Promotions",
          disabled: false,
          href: "/owner/promotions",
        },
        {
          text: "List",
          disabled: false,
          href: "/owner/promotions/list",
        },
        {
          text: "View",
          disabled: true,
          href: "/owner/promotions/list/view/" + this.promotion_id,
        },
      ],
      navbar_cols: 3,
    });
    this.load_promotion();

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#owner_view_prmotion_details_view", options);
  },
};
</script>